
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    ListItemIcon, ListItemText, Menu, Stack,
    Tooltip
} from "@mui/material";

// App Imports

import {
    deleteLicense, licenseSearch
} from "./LicenseClient";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {changeLicense} from "./licenseSlice";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import LicenseDrawer from "./LicenseDrawer";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import CrudSnackbar from "../../CommonComponents/CrudSnackbar";
import {changeUploadFile} from "../../CommonComponents/UploadFile/uploadFileSlice";
import Button from "@mui/material/Button";
import UploadFileDrawer from "../../CommonComponents/UploadFile/UploadFileDrawer";
import SearchIcon from "@mui/icons-material/Search";
import LicenseSearch from "./LicenseSearch";
import AddFiltersExportToolbar from "../../CommonComponents/AddFiltersExportToolbar";
import {PlatformGridColumns} from "../Platform/PlatformGridColumns";
import {changePlatform} from "../Platform/platformSlice";
import {LicenseGridColumns} from "./LicenseGridColumns";
import {changeExternalData} from "../externalDataSlice";
import NoSearchCriteriaSnackbar from "../../CommonComponents/NoSearchCriteriaSnackbar";
import LicenseInfoDialogue from "./Info/LicenseInfoDialogue";


// main function
export default function LicenseGrid() {

    // ****************** BEGIN STATES ****************************

    const [licenses, setLicenses] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [showControls, setShowControls] = useState(true);
    const [showSearch, setShowSearch] = useState(false);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const [licenseInfoOpen, setLicenseInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorLicenseId = useSelector((state) => state.licenseSlc.value.id);
    const selectorLicenseMcode = useSelector((state) => state.licenseSlc.value.mcode);
    const selectorLicenseName = useSelector((state) => state.licenseSlc.value.name);
    const selectorLicenseDescription = useSelector((state) => state.licenseSlc.value.description);
    const selectorLicenseCategory = useSelector((state) => state.licenseSlc.value.category);
    const selectorDrawerState = useSelector((state) => state.licenseSlc.value.licenseDrawerState);


    const selectorPropertyId = useSelector((state) => state.licenseSearchSlc.value.propertyId);
    const selectorProductName = useSelector((state) => state.licenseSearchSlc.value.productName);
    const selectorEpisodeName = useSelector((state) => state.licenseSearchSlc.value.episodeName);
    const selectorPhotoStartDateFrom = useSelector((state) => state.licenseSearchSlc.value.photoStartDateFrom);
    const selectorPhotoStartDateTo = useSelector((state) => state.licenseSearchSlc.value.photoStartDateTo);
    const selectorSeriesExternalId = useSelector((state) => state.licenseSearchSlc.value.seriesExternalId);
    const selectorSeriesName = useSelector((state) => state.licenseSearchSlc.value.seriesName);
    const selectorSeasonExternalId = useSelector((state) => state.licenseSearchSlc.value.seasonExternalId);
    const selectorSeasonNumberFrom = useSelector((state) => state.licenseSearchSlc.value.seasonNumberFrom);
    const selectorSeasonNumberTo = useSelector((state) => state.licenseSearchSlc.value.seasonNumberTo);
    const selectorSeasonName = useSelector((state) => state.licenseSearchSlc.value.seasonName);
    const selectorLicensee = useSelector((state) => state.licenseSearchSlc.value.licensee);
    const selectorId = useSelector((state) => state.licenseSearchSlc.value.id);
    const selectorExternalId = useSelector((state) => state.licenseSearchSlc.value.externalId);
    const selectorAmountFrom = useSelector((state) => state.licenseSearchSlc.value.amountFrom);
    const selectorAmountTo = useSelector((state) => state.licenseSearchSlc.value.amountTo);
    const selectorAvailBeginFrom = useSelector((state) => state.licenseSearchSlc.value.availBeginFrom);
    const selectorAvailBeginTo = useSelector((state) => state.licenseSearchSlc.value.availBeginTo);
    const selectorAvailEndFrom = useSelector((state) => state.licenseSearchSlc.value.availEndFrom);
    const selectorAvailEndTo = useSelector((state) => state.licenseSearchSlc.value.availEndTo);
    const selectorExecutionDateFrom = useSelector((state) => state.licenseSearchSlc.value.executionDateFrom);
    const selectorExecutionDateTo = useSelector((state) => state.licenseSearchSlc.value.executionDateTo);
    const selectorMarket = useSelector((state) => state.licenseSearchSlc.value.market);
    const selectorTerritory = useSelector((state) => state.licenseSearchSlc.value.territory);
    const selectorParticipations = useSelector((state) => state.licenseSearchSlc.value.participations);
    const selectorResiduals = useSelector((state) => state.licenseSearchSlc.value.residuals);
    const selectorRoyalties = useSelector((state) => state.licenseSearchSlc.value.royalties);

    const selectorUploadFileDrawerState = useSelector((state) => state.uploadFileSlc.value.uploadFileDrawerState);

    const selectedId = useSelector((state) => state.licenseSlc.value.id);

    const dispatchData = useDispatch();

    const selectorLicenseGridRefresh = useSelector((state) => state.licenseSlc.value.licenseGridRefresh);

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************
    //
    // const fetchLicenses = () =>{
    //     if(
    //         selectorPropertyId !== null ||
    //         selectorProductName !== null ||
    //         selectorEpisodeName !== null ||
    //         selectorPhotoStartDateFrom !== null ||
    //         selectorPhotoStartDateTo !== null ||
    //         selectorSeriesExternalId !== null ||
    //         selectorSeriesName !== null ||
    //         selectorSeasonExternalId !== null ||
    //         selectorSeasonNumberFrom !== null ||
    //         selectorSeasonNumberTo !== null ||
    //         selectorSeasonName !== null ||
    //         selectorLicensee !== null ||
    //             selectorId !== null ||
    //             selectorExternalId !== null ||
    //             selectorAmountFrom !== null ||
    //             selectorAmountTo !== null ||
    //             selectorAvailBeginFrom !== null ||
    //             selectorAvailBeginTo !== null ||
    //             selectorAvailEndFrom !== null ||
    //             selectorAvailEndTo !== null ||
    //             selectorExecutionDateFrom !== null ||
    //             selectorExecutionDateTo !== null ||
    //             selectorMarket !== null ||
    //             selectorTerritory !== null ||
    //
    //         selectorParticipations !== null ||
    //         selectorResiduals !== null ||
    //         selectorRoyalties !== null
    //     )
    //     {
    //         {
    //             console.log("search triggered");
    //             licenseSearch(
    //                 selectorPropertyId,
    //                 selectorProductName,
    //                 selectorEpisodeName,
    //                 selectorPhotoStartDateFrom,
    //                 selectorPhotoStartDateTo,
    //                 selectorSeriesExternalId,
    //                 selectorSeriesName,
    //                 selectorSeasonExternalId,
    //                 selectorSeasonNumberFrom,
    //                 selectorSeasonNumberTo,
    //                 selectorSeasonName,
    //                 selectorLicensee,
    //                 selectorId,
    //                 selectorExternalId,
    //                 selectorAmountFrom,
    //                 selectorAmountTo,
    //                 selectorAvailBeginFrom,
    //                 selectorAvailBeginTo,
    //                 selectorAvailEndFrom,
    //                 selectorAvailEndTo,
    //                 selectorExecutionDateFrom,
    //                 selectorExecutionDateTo,
    //                 selectorMarket,
    //                 selectorTerritory,
    //                 selectorParticipations,
    //                 selectorResiduals,
    //                 selectorRoyalties
    //             )

    //                 .then(data => {
    //                         console.log(data);
    //                         setLicenses(data);
    //                     }
    //                 )
    //         }
    //     }
    //     else{console.log("search triggered, nothing to search.")}}

    const fetchLicenses = () => {

        const request = {

            propertyId: selectorPropertyId,

            productName: selectorProductName,

            episodeName: selectorEpisodeName,

            photoStartDateFrom: selectorPhotoStartDateFrom,
            photoStartDateTo: selectorPhotoStartDateTo,

            seriesExternalId: selectorSeriesExternalId,

            seriesName: selectorSeriesName,

            seasonExternalId: selectorSeasonExternalId,

            seasonNumberFrom: selectorSeasonNumberFrom,
            seasonNumberTo: selectorSeasonNumberTo,

            seasonName: selectorSeasonName,

            licensee: selectorLicensee,

            id: selectorId,

            externalId: selectorExternalId,

            amountFrom: selectorAmountFrom,
            amountTo: selectorAmountTo,

            availBeginFrom: selectorAvailBeginFrom,
            availBeginTo: selectorAvailBeginTo,

            availEndFrom: selectorAvailEndFrom,
            availEndTo: selectorAvailEndTo,

            executionDateFrom: selectorExecutionDateFrom,
            executionDateTo: selectorExecutionDateTo,

            market: selectorMarket,

            territory: selectorTerritory,

            participations: selectorParticipations,

            residuals: selectorResiduals,

            royalties: selectorRoyalties
        };

        console.log(
            JSON.stringify(request, null, 2)
        );

        const hasSearchCriteria = Object.values(request).some(
            value =>
                value !== null &&
                value !== undefined &&
                value !== ''
        );

        if (hasSearchCriteria) {

            dispatchData(changeExternalData({ submitting: true }));

            console.log("search triggered");

            licenseSearch(request)



                .then(data => {

                    console.log(data);

                    setLicenses(data);

                    if (!data || data.length === 0) {
                        console.log("no matching records found");
                        dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "info", snackbarMessage: "No matching records found" }));
                    }

                })

                .catch(err => {

                    console.error(err);

                })

                .finally(() => {

                    // setSubmitting(false);
                    dispatchData(changeExternalData({ submitting: false }));
                });

        } else {

            console.log(
                "search triggered, nothing to search."
            );
            dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "warning", snackbarMessage: "No search criteria provided" }));
        }
    };

    // ****************** END FETCH ****************************

    const handleUploadFileDrawer = () => {
        console.log("upload file drawer state changed");
        dispatchData(changeUploadFile({uploadFileDrawerState: true,
            uploadFileDrawerMode: "License"}));
    };

    const renderLicenses = licenses => {
        if (licenses.length <= 0) {
            return "No Data";
        }}

    function handleControls(){
        setShowControls(!showControls)
    }

    function handleSearch(){
        setShowSearch(!showSearch)
    }
    //
    // useEffect(() => {
    //     fetchLicenses();
    //     dispatchData(changeLicense({licenseGridRefresh: false}));
    // }, [useSelector((state) => state.licenseSlc.value.licenseGridRefresh)===true]);


    useEffect(() => {

        if (selectorLicenseGridRefresh) {

            fetchLicenses();

            dispatchData(changeLicense({
                licenseGridRefresh: false
            }));
        }

    }, [selectorLicenseGridRefresh]);

    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changeLicense({id: null, externalId: null, licenseAmount: null, displayAmount: null, availBegin: null,
            availEnd: null, executionDate: null, licensee: null, market: null, territory: null,
            propertyId: null, exhibitionDays: null, runs: null, status: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            propertyName: null, initialMarket: null, genre: null, productionType: null,
            licenseDrawerState: true, licenseDrawerMode: "Add"}));
    };

    const removeLicense = () => {
        deleteLicense(selectorLicenseId).then(() => {
            // successNotification("Data Point Attribute deleted", `Data Point Attribute with id ${selectorLicenseId} was deleted`);
            setDeleteOpen(false);
            dispatchData(changeLicense({licenseGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    const handleDeleteOpen = () => {
        setDeleteOpen(true);
    };


    function DeleteConfirmationDialog() {

        const handleClickOpen = () => {
            setDeleteOpen(true);
        };

        const handleClose = () => {
            setDeleteOpen(false);
        };


        const handleDelete = () => {
            deleteLicense(selectedId).then(() => {
                setDeleteOpen(false);
                dispatchData(changeLicense({licenseGridRefresh: true}));
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
            })
            console.log('Item deleted');
        };

        return (
            <Dialog
                open={deleteOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'transparent', // makes backdrop transparent
                        boxShadow: '0 0 10px 5px rgba(0, 0, 0, 0.5)' // custom shadow box effect
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this item? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleDelete} autoFocus color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };


    const gridClear = () => {

        setLicenses([]);
    }



    // ****************** END CRUD ***********************************



    // ****************** BEGIN DRILLDOWN ****************************

    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (licenses) => {

        console.log('License data from clicked row');
        console.log(licenses);
        dispatchData(changeLicense({id: licenses.id,
            externalId: licenses.externalId, licenseAmount: licenses.amount, displayAmount: licenses.displayAmount,
            availBegin: licenses.availBegin, availEnd: licenses.availEnd,
            executionDate: licenses.executionDate, licensee: licenses.licensee,
            licenseMarket: licenses.market, licenseTerritory: licenses.territory,
            propertyId: licenses.propertyId, exhibitionDays: licenses.exhibitionDays, licensedRuns: licenses.licensedRuns, status: licenses.status,
            createdOn: licenses.createdOn,createdBy:licenses.createdBy,lastModifiedOn:licenses.lastModifiedOn,lastModifiedBy:licenses.lastModifiedBy,
            propertyName: licenses.propertyName, initialMarket: licenses.initialMarket,
            genre: licenses.genre, productionType: licenses.productionType}));
    };


    const handleLicenseInfo = () => {
        setLicenseInfoOpen(true);
    };

    const handleCloseLicenseInfo = () => {
        setLicenseInfoOpen(false);
    };



    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 80, pt: 1, pl: 3}}>
                <Stack direction={"horizontal"}>
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
                    <h3
                        style={{cursor:'pointer'}}   onClick={() => handleLicenseInfo()}
                    >Licenses</h3>
                        <LicenseInfoDialogue
                            open={licenseInfoOpen}
                            onClose={handleCloseLicenseInfo}
                        />
                    </Tooltip>
                    {/*<SearchIcon*/}
                    {/*    sx={{pt: 2, ml: 2}}*/}
                    {/*    color={'primary'}*/}
                    {/*    onClick={handleSearch}*/}
                    {/*/>*/}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            color="primary"
                            size="large"               // large icon & hit area
                            onClick={handleSearch}
                            sx={{ ml: 2 }}             // any spacing you want
                        >
                            <SearchIcon fontSize="inherit" />
                        </IconButton>
                    </Box>
                    <Button sx={{pt: 1, ml: 3}}
                            onClick={handleUploadFileDrawer}
                    >Upload</Button>
                </Stack>
            </Box>
                {showSearch && <LicenseSearch
                    gridClear = {gridClear}
                />}
                {selectorUploadFileDrawerState && <UploadFileDrawer/>}
            {selectorDrawerState && <LicenseDrawer
            />}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"Licenses"}
                rows={licenses}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={LicenseGridColumns({
                    hideActions,
                    onEdit: () => dispatchData(changeLicense({ licenseDrawerState: true, licenseDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeLicense({ licenseDrawerState: true, licenseDrawerMode: "Clone" })),
                    onDelete: removeLicense
                })}
                onRowClick = {(licenses)=>handleClickedRow(licenses.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={license => license.id}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}
            />}
            <CrudSnackbar/>
            <NoSearchCriteriaSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}


